module.exports = __webpack_public_path__ + "img/btn_home_ov.7d5e19ac.png";